export default "__VITE_ASSET__355abd28__"